import {register} from 'register-service-worker'
import {appUpdateRegistration} from '@/tools/appUpdate';

function showUpdateNotification(registration) {
    if (!registration.waiting) {
        return;
    }

    appUpdateRegistration.value = registration;
}

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        updated: showUpdateNotification,
    });
}
